/* eslint-disable */
import React, { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import { DASHBOARD_URL, IMPORT_DN_CREATIONS_API_URL } from "./constant";
import { Button, Dropdown, Spinner, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { GetOrderDetailByOrderCode, ClearFormSetFutios } from "../../redux/actions/adminActions";
import CommonSearchNavigationsButton from "../Common/CommonSearchNavigationsButton";
import { IMPORT_SALES_TARGET_API_URL } from "./constant";
import CommonLogout from "../Common/CommonLogout";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CommonSplitScreenList from "../Common/CommonSplitScreenList";
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";
import StockSyncAPI from "../../Api/StockSyncAPI";
import CommonLoader from "../Common/CommonLoader";
import CommonModalLogout from "../Common/CommonModalLogout";
import SidebarFull from "../../assets/img/sidebar-full.svg";
import SidebarClosed from "../../assets/img/sidebar-close.svg";
import SampleDNFile from "../../assets/file/sample_dn_orders.xls";

const Header = (props) => {
    const { sidebarToggle, setSidebarToggle } = props;
    const dispatch = useDispatch();
    const PageName = useLocation()?.pathname?.split("/")[1]?.replaceAll("-", " ");
    const { selfInfo, device_id, accessToken, OrderSynceTab } = useSelector((state) => state.adminReducers);
    const [ LogoutModal, setLogoutModal ] = useState(false);
    const [ showModalNew, setShowModalNew ] = useState({
        open: false,
        title: "",
        modalType: "",
        Data: {}
    });
    const PermissionsAccess = selfInfo?.user?.permissions_access;
    const [ LoaderStart, setLoaderStart ] = useState(false);
    const [ stockSyncLoaderStart, setstockSyncLoaderStart ] = useState(false);
    const [ splitScreenModal, setsplitScreenModal ] = useState({
        open: false,
        error: true,
        title: "",
        list: [],
    });
    const { websocket } = useContext(WebSocketContext);

    // page title get on header
    const PageTitle = () => {
        const PageNameCheck = PageName === "e invoice details" ? "e-invoice details" : PageName === "e invoice cancel" ? "e-invoice cancel" : PageName === "e way bill report" ? "e-way bill report" : PageName === "afs so creation" ? "AFS SO Creation" : PageName === "notifications and cms" ? "Notifications and CMS" : PageName === "create notifications and cms" ? "Create Notifications And CMS" : PageName;
        if(Location === DASHBOARD_URL || Location === "/") {
            return PageNameCheck ;
        } else {
            return PageNameCheck;
        }
    };

    // logout function
    const LogoutFnct = (e) => {
        setLogoutModal(!LogoutModal);
    };

    useEffect(() => {
        dispatch(GetOrderDetailByOrderCode({}));
    }, [ PageTitle() ]);

    // import monthly target API
    const ImportSalesFranchiseTarget = async (e) => {
        setLoaderStart(true);
        const files = e?.target?.files[0];
        const formData = new FormData();
        formData.append("file", files, files.name);
        window.axios.post(IMPORT_SALES_TARGET_API_URL, formData, {
            headers: {
              'Authorization': 'Bearer ' + accessToken,
            },
        }).then(function (result) {
            APICall();
            setLoaderStart(false);
            toast.info(result?.data?.message);
            document.getElementById('fileInput').value = null;

            setTimeout(() => {
                if(PageName === "add sales person performance") {
                    dispatch(ClearFormSetFutios({
                        url: "import_sales_scheme_target",
                        action: result?.status
                    }));
                };
            }, 500);
        }).catch(function (result) {
            const erroResponse = result?.response?.data;
            if(typeof erroResponse === 'string') {
                const erroResponseMian = JSON.parse(erroResponse?.replaceAll("NaN", null))
                APICall("import_monthly_target");
                setLoaderStart(false);
                document.getElementById('fileInput').value = null;
                if(erroResponseMian?.success) {
                    showErrorToast(erroResponseMian, "import_monthly_target");

                    setTimeout(() => {
                        if(PageName === "add sales person performance") {
                            dispatch(ClearFormSetFutios({
                                url: "import_sales_scheme_target",
                                action: 200
                            }));
                        };
                    }, 500);
                } else {
                    showErrorToast(erroResponseMian, "import_monthly_target");
                };
            } else {
                setLoaderStart(false);
                document.getElementById('fileInput').value = null;
                if(erroResponse?.message === "User is not authorized.") {
                    toast.error(erroResponse?.message);
                    CommonLogout(accessToken, dispatch);
                    localStorage?.removeItem("access_token");
                } else {
                    if(erroResponse?.data?.success) {
                        showErrorToast(erroResponse, "import_monthly_target");
                        setTimeout(() => {
                            if(PageName === "add sales person performance") {
                                dispatch(ClearFormSetFutios({
                                    url: "import_sales_scheme_target",
                                    action: 200
                                }));
                            };
                        }, 500);
                    } else {
                        showErrorToast(erroResponse, "import_monthly_target");
                    };
                }
            }
        });
    };

    // import dn creations
    const ImportDnCreations = async (e) => {
        setLoaderStart(true);
        const files = e?.target?.files[0];
        const formData = new FormData();
        formData.append("file", files, files.name);
        window.axios.post(IMPORT_DN_CREATIONS_API_URL, formData, {
            headers: {
              'Authorization': 'Bearer ' + accessToken,
            },
        }).then(function (result) {
            APICall("import_dn_creations");
            setLoaderStart(false);
            const ErrorCheckValid = result?.data?.data?.result?.filter((elm) => elm?.status === "error");
            if(ErrorCheckValid?.length > 0) {
                showErrorToast(ErrorCheckValid, "import_dn_creations");
            } else {
                if(result?.data?.data?.error) {
                    toast.error(result?.data?.data?.error);
                } else {
                    toast.info(result?.data?.message);
                };
            };
            document.getElementById('fileInput').value = null;
        }).catch(function (result) {
            APICall();
            document.getElementById('fileInput').value = null;
            const erroResponse = result?.response?.data;
            if(erroResponse?.message === "User is not authorized.") {
                toast.error(erroResponse?.message);
                CommonLogout(accessToken, dispatch);
                localStorage?.removeItem("access_token");
            } else {
                if(erroResponse?.data?.success) {
                    showErrorToast(erroResponse, "import_dn_creations");
                } else {
                    showErrorToast(erroResponse, "import_dn_creations");
                };
            }
        });
    };

    // show error toast message
    const showErrorToast = (fileresponse, url) => {
        if(url === "import_monthly_target") {
            const toastId = toast.error(
                <div>
                    {fileresponse?.message}{" "} Click on View to show the rejected list
                    <button 
                        className="btn btn-view" 
                        onClick={() => ViewRejectedList(fileresponse?.data?.excluded_emails, toastId, url)}>
                        View
                    </button>
                </div>,
                {
                    autoClose: 10000, // Time in milliseconds (10000ms = 10 seconds)
                }
            );
        } else if(url === "import_dn_creations") {
            const toastId = toast.info(
                <div>
                    Data imported successfully, but some of the imported orders have errors. Click 'View' to display the rejected list.
                    <button 
                        className="btn btn-view" 
                        onClick={() => ViewRejectedList(fileresponse, toastId, url)}>
                        View
                    </button>
                </div>,
                {
                    autoClose: 10000, // Time in milliseconds (10000ms = 10 seconds)
                }
            );
        };
    };

    // view Sale Franchise Person list
    const ViewRejectedList = (emails, toastId, url) => {
        toast.dismiss(toastId);
        setsplitScreenModal({
            ...splitScreenModal,
            open: true,
            error: true,
            title: url === "import_monthly_target" ? "Rejected Sale Franchise Person List" : "Rejected Delivery Note Orders List",
            list: emails,
        });
    };

    // salesperson_performance_list api calling
    const APICall = (url) => {
        if(url === "import_monthly_target") {
            let param = { 
                "transmit": "broadcast", 
                "url": "admin_scheme_report",
                "request" : { 
                    "limit" : 10,
                    "page_no" : 1, 
                    "franchise_id" : null,
                    "search" : null,
                    "order_by" :"-updated_at",
                    "franchise_id" : null,
                    "scheme_code": null,
                    "from_date": null,
                    "to_date": null,
                },
                "DeviceId" : device_id
            };
            wsSend_request(websocket, param);
        } else if(url === "import_dn_creations") {
            let param = {
                "transmit": "broadcast",
                "url": "erp_order_log_list",
                "request": {
                    "limit": 10,
                    "page_no": 1,
                    "order_status":"FAILURE",
                    "is_delivery": true,
                    "search": null,
                    "order_by": "-updated_at",
                    "is_return": false,
                },
                "DeviceId": device_id
            };
            wsSend_request(websocket, param);
        };
    };

    // stock sync function
    const StockSync = async () => {
        setstockSyncLoaderStart(true);
        const responce = await StockSyncAPI(accessToken);
        if(responce?.status === 200) {
            setstockSyncLoaderStart(false);
            toast.info(responce?.message);
        } else {
            setstockSyncLoaderStart(false);
            if(responce?.status === 403) {
                CommonLogout(accessToken, dispatch);
                localStorage?.removeItem("access_token");
            } else if(responce?.status === 500) { 
                toast.error("Internal Server Error :- " + responce?.message);
            } else {
                toast.error(responce?.message);
            };
        };
    };
    
    return(<div className="head_section">
        <h4 className="pageTitle">
            <Button 
                className="Header-Minimize-Toggle"
                onClick={() => setSidebarToggle(!sidebarToggle)}
            >
                <img src={sidebarToggle ? SidebarClosed : SidebarFull} alt="sidebar" className="sidebarIcon" />
            </Button>
            {PageTitle()}
        </h4>
        {((selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.CRMTools?.[2]?.Edit) && (PageName === "sales person performance" || PageName === "add sales person performance")) && (<div className="sales_person_uplaod_downlo_wrapper">
            <label className="btn import_monthly_target" >
                <input type="file" id="fileInput" accept=".xlsx, .xls" disabled={LoaderStart} onChange={(e) => ImportSalesFranchiseTarget(e)} />
                {LoaderStart ? (<Spinner />) : (<i className="bi bi-upload"></i>)}&nbsp; Import Sale Person Target
            </label>
        </div>)}
        {((selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.Store?.[1]?.Edit || PermissionsAccess?.Store?.[5]?.Edit)) && (PageName === "stock level" || PageName === "erp stock level")) && (<div className="sales_person_uplaod_downlo_wrapper">
            <button className="btn import_monthly_target" onClick={() => StockSync()}>
                <i className="bi bi-arrow-repeat"></i> Uniware Stock Sync
            </button>
        </div>)}
        {(selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.OrderManagement?.[15]?.Edit) && (OrderSynceTab === "delivery_note_frame_number" && PageName === "erp api failures") && (<div id="importDNCreations" className="sales_person_uplaod_downlo_wrapper">
            <label className="btn import_monthly_target" >
                <input type="file" id="fileInput" accept=".xlsx, .xls" disabled={LoaderStart} onChange={(e) => ImportDnCreations(e)} />
                {LoaderStart ? (<Spinner />) : (<i className="bi bi-upload"></i>)}&nbsp; Import DN Creation
            </label>
            <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 100 }}
                overlay={<Tooltip style={{ position: "fixed" }} id="button-tooltip" {...props}>
                Sample File
            </Tooltip>}
            >
            <a href={SampleDNFile} className="btn exportbtn" style={{ width: "auto", marginTop: "0px" }}>
                <i className="bi bi-download"></i>
            </a>
            </OverlayTrigger>
        </div>)}
        <CommonSearchNavigationsButton setLogoutModal={setLogoutModal} />
        <div className="dropdownHeader">
            <Dropdown>
                <Dropdown.Toggle id="dropdown-basic">
                    <i className="bi bi-person-fill"></i>
                    <div className="profilUser">
                        <h4>{selfInfo?.user?.full_name}</h4>
                        <small>{(selfInfo?.user?.user_type === 'regional_manager' || selfInfo?.user?.user_type === 'regional_sales_team_rm') ? "Regional Manager" : (selfInfo?.user?.user_type === 'regional_sales_team_asm') ? "Assistant Sales Manager" : selfInfo?.user?.user_type?.replaceAll("_", " ")}</small>
                    </div> 
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => LogoutFnct()}>Logout</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>

        {LogoutModal && (<CommonModalLogout 
            LogoutModal={LogoutModal} 
            setLogoutModal={setLogoutModal}
        />)}

        {splitScreenModal?.open && (<CommonSplitScreenList 
            splitScreenModal={splitScreenModal} 
            setsplitScreenModal={setsplitScreenModal}
        />)}

        {stockSyncLoaderStart && (<CommonLoader />)}
    </div>)
}

export default Header;